/* ================================================================
   Cart Add-on Upsells JS — Gulab / Horizon Theme
   Handles: AJAX add to cart, button states, cart refresh,
            hide-if-in-cart, MutationObserver re-init
   ================================================================ */

(function CartAddonUpsells() {
  'use strict';

  const SECTION_SEL   = '.cart-addon-upsells';
  const CARD_SEL      = '.cart-addon-card';
  const BTN_SEL       = '.cart-addon-card__btn';
  const IN_CART_ATTR  = 'data-in-cart';

  /* ── Utility: check which variant IDs are in cart ── */
  function getCartVariantIds() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        return cart.items.map(function(i) { return String(i.variant_id); });
      });
  }

  /* ── Mark cards already in cart ── */
  function markInCartCards(section, inCartIds) {
    const cards = section.querySelectorAll(CARD_SEL);
    cards.forEach(function(card) {
      const vid = card.dataset.variantId;
      const alreadyIn = inCartIds.includes(vid);
      card.setAttribute(IN_CART_ATTR, alreadyIn ? 'true' : 'false');
      const btn = card.querySelector(BTN_SEL);
      if (btn && alreadyIn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('cart-addon-card__btn--added');
        btn.innerHTML = '<span>&#10003; Added</span>';
      }
    });
  }

  /* ── AJAX add to cart ── */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    }).then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    });
  }

  /* ── Refresh Horizon cart drawer ── */
  function refreshCart() {
    // 1. Horizon native cart-items-component
    const comp = document.querySelector('cart-items-component[data-drawer]');
    if (comp && typeof comp.refresh === 'function') {
      comp.refresh();
      return;
    }

    // 2. Custom events Horizon listens to
    ['cart:refresh', 'cart:updated'].forEach(function(evt) {
      document.dispatchEvent(new CustomEvent(evt, { bubbles: true }));
    });

    // 3. Update header cart bubble count
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function(el) {
          const span = el.querySelector('[aria-hidden="true"]') || el.querySelector('span');
          if (span) span.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
        });
      })
      .catch(function() {});
  }

  /* ── Button click handler ── */
  function handleBtnClick(btn, card) {
    if (btn.disabled) return;

    const variantId = card.dataset.variantId;
    if (!variantId) return;

    // Loading state
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    const originalText = btn.innerHTML;
    btn.innerHTML = '<span class="cart-addon-btn-spinner"></span><span>Adding&hellip;</span>';

    addToCart(variantId)
      .then(function() {
        // Success
        btn.classList.add('cart-addon-card__btn--added');
        btn.innerHTML = '<span>&#10003; Added</span>';

        // Optionally hide card after short delay
        setTimeout(function() {
          card.setAttribute(IN_CART_ATTR, 'true');
        }, 1200);

        refreshCart();
      })
      .catch(function(err) {
        console.error('[CartAddon] Add to cart failed:', err);
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.innerHTML = originalText;
        btn.classList.add('cart-addon-card__btn--error');
        setTimeout(function() {
          btn.classList.remove('cart-addon-card__btn--error');
        }, 2500);
      });
  }

  /* ── Attach listeners to one section ── */
  function bindSection(section) {
    if (section.dataset.cartAddonBound === 'true') return;
    section.dataset.cartAddonBound = 'true';

    // Check which cards are already in cart
    getCartVariantIds()
      .then(function(ids) { markInCartCards(section, ids); })
      .catch(function() {});

    // Bind buttons
    section.querySelectorAll(BTN_SEL).forEach(function(btn) {
      const card = btn.closest(CARD_SEL);
      if (!card) return;
      btn.addEventListener('click', function() { handleBtnClick(btn, card); });
    });
  }

  /* ── Init all sections on page ── */
  function init() {
    document.querySelectorAll(SECTION_SEL).forEach(bindSection);
  }

  /* ── Re-init on cart refresh (Horizon re-renders drawer) ── */
  function onCartEvent() {
    // Unbind all so we re-check in-cart state
    document.querySelectorAll(SECTION_SEL).forEach(function(s) {
      delete s.dataset.cartAddonBound;
    });
    setTimeout(init, 350);
  }

  ['cart:updated', 'cart:refresh', 'shopify:section:load'].forEach(function(e) {
    document.addEventListener(e, onCartEvent);
  });

  /* ── MutationObserver: detect when drawer injects sections ── */
  new MutationObserver(function(mutations) {
    var found = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType === 1) {
          if (n.matches && n.matches(SECTION_SEL)) { found = true; }
          else if (n.querySelector && n.querySelector(SECTION_SEL)) { found = true; }
        }
      });
    });
    if (found) setTimeout(init, 100);
  }).observe(document.body, { childList: true, subtree: true });

  /* ── Bootstrap ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
